import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import SpeakerCard from '../components/speaker-card.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Toggle from '../components/toggle.js';
import SearchableDropdown from '../components/searchable-dropdown.js';

const countries = [
  {name: 'United States', code: 'US'}, 
  {name: 'Canada', code: 'CA'}, 
  {name: 'United Kingdom', code: 'GB'},
  {name: 'Afghanistan', code: 'AF'}, 
  {name: 'Åland Islands', code: 'AX'}, 
  {name: 'Albania', code: 'AL'}, 
  {name: 'Algeria', code: 'DZ'}, 
  {name: 'American Samoa', code: 'AS'}, 
  {name: 'Andorra', code: 'AD'}, 
  {name: 'Angola', code: 'AO'}, 
  {name: 'Anguilla', code: 'AI'}, 
  {name: 'Antarctica', code: 'AQ'}, 
  {name: 'Antigua and Barbuda', code: 'AG'}, 
  {name: 'Argentina', code: 'AR'}, 
  {name: 'Armenia', code: 'AM'}, 
  {name: 'Aruba', code: 'AW'}, 
  {name: 'Australia', code: 'AU'}, 
  {name: 'Austria', code: 'AT'}, 
  {name: 'Azerbaijan', code: 'AZ'}, 
  {name: 'Bahamas', code: 'BS'}, 
  {name: 'Bahrain', code: 'BH'}, 
  {name: 'Bangladesh', code: 'BD'}, 
  {name: 'Barbados', code: 'BB'}, 
  {name: 'Belarus', code: 'BY'}, 
  {name: 'Belgium', code: 'BE'}, 
  {name: 'Belize', code: 'BZ'}, 
  {name: 'Benin', code: 'BJ'}, 
  {name: 'Bermuda', code: 'BM'}, 
  {name: 'Bhutan', code: 'BT'}, 
  {name: 'Bolivia', code: 'BO'}, 
  {name: 'Bosnia and Herzegovina', code: 'BA'}, 
  {name: 'Botswana', code: 'BW'}, 
  {name: 'Bouvet Island', code: 'BV'}, 
  {name: 'Brazil', code: 'BR'}, 
  {name: 'British Indian Ocean Territory', code: 'IO'}, 
  {name: 'Brunei Darussalam', code: 'BN'}, 
  {name: 'Bulgaria', code: 'BG'}, 
  {name: 'Burkina Faso', code: 'BF'}, 
  {name: 'Burundi', code: 'BI'}, 
  {name: 'Cambodia', code: 'KH'}, 
  {name: 'Cameroon', code: 'CM'},
  {name: 'Cape Verde', code: 'CV'}, 
  {name: 'Cayman Islands', code: 'KY'}, 
  {name: 'Central African Republic', code: 'CF'}, 
  {name: 'Chad', code: 'TD'}, 
  {name: 'Chile', code: 'CL'}, 
  {name: 'China', code: 'CN'}, 
  {name: 'Christmas Island', code: 'CX'}, 
  {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
  {name: 'Colombia', code: 'CO'}, 
  {name: 'Comoros', code: 'KM'}, 
  {name: 'Congo', code: 'CG'}, 
  {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
  {name: 'Cook Islands', code: 'CK'}, 
  {name: 'Costa Rica', code: 'CR'}, 
  {name: 'Cote D\'Ivoire', code: 'CI'}, 
  {name: 'Croatia', code: 'HR'}, 
  {name: 'Cuba', code: 'CU'}, 
  {name: 'Cyprus', code: 'CY'}, 
  {name: 'Czech Republic', code: 'CZ'}, 
  {name: 'Denmark', code: 'DK'}, 
  {name: 'Djibouti', code: 'DJ'}, 
  {name: 'Dominica', code: 'DM'}, 
  {name: 'Dominican Republic', code: 'DO'}, 
  {name: 'Ecuador', code: 'EC'}, 
  {name: 'Egypt', code: 'EG'}, 
  {name: 'El Salvador', code: 'SV'}, 
  {name: 'Equatorial Guinea', code: 'GQ'}, 
  {name: 'Eritrea', code: 'ER'}, 
  {name: 'Estonia', code: 'EE'}, 
  {name: 'Ethiopia', code: 'ET'}, 
  {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
  {name: 'Faroe Islands', code: 'FO'}, 
  {name: 'Fiji', code: 'FJ'}, 
  {name: 'Finland', code: 'FI'}, 
  {name: 'France', code: 'FR'}, 
  {name: 'French Guiana', code: 'GF'}, 
  {name: 'French Polynesia', code: 'PF'}, 
  {name: 'French Southern Territories', code: 'TF'}, 
  {name: 'Gabon', code: 'GA'}, 
  {name: 'Gambia', code: 'GM'}, 
  {name: 'Georgia', code: 'GE'}, 
  {name: 'Germany', code: 'DE'}, 
  {name: 'Ghana', code: 'GH'}, 
  {name: 'Gibraltar', code: 'GI'}, 
  {name: 'Greece', code: 'GR'}, 
  {name: 'Greenland', code: 'GL'}, 
  {name: 'Grenada', code: 'GD'}, 
  {name: 'Guadeloupe', code: 'GP'}, 
  {name: 'Guam', code: 'GU'}, 
  {name: 'Guatemala', code: 'GT'}, 
  {name: 'Guernsey', code: 'GG'}, 
  {name: 'Guinea', code: 'GN'}, 
  {name: 'Guinea-Bissau', code: 'GW'}, 
  {name: 'Guyana', code: 'GY'}, 
  {name: 'Haiti', code: 'HT'}, 
  {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
  {name: 'Holy See (Vatican City State)', code: 'VA'}, 
  {name: 'Honduras', code: 'HN'}, 
  {name: 'Hong Kong', code: 'HK'}, 
  {name: 'Hungary', code: 'HU'}, 
  {name: 'Iceland', code: 'IS'}, 
  {name: 'India', code: 'IN'}, 
  {name: 'Indonesia', code: 'ID'}, 
  {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
  {name: 'Iraq', code: 'IQ'}, 
  {name: 'Ireland', code: 'IE'}, 
  {name: 'Isle of Man', code: 'IM'}, 
  {name: 'Israel', code: 'IL'}, 
  {name: 'Italy', code: 'IT'}, 
  {name: 'Jamaica', code: 'JM'}, 
  {name: 'Japan', code: 'JP'}, 
  {name: 'Jersey', code: 'JE'}, 
  {name: 'Jordan', code: 'JO'}, 
  {name: 'Kazakhstan', code: 'KZ'}, 
  {name: 'Kenya', code: 'KE'}, 
  {name: 'Kiribati', code: 'KI'}, 
  {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
  {name: 'Korea, Republic of', code: 'KR'}, 
  {name: 'Kuwait', code: 'KW'}, 
  {name: 'Kyrgyzstan', code: 'KG'}, 
  {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
  {name: 'Latvia', code: 'LV'}, 
  {name: 'Lebanon', code: 'LB'}, 
  {name: 'Lesotho', code: 'LS'}, 
  {name: 'Liberia', code: 'LR'}, 
  {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
  {name: 'Liechtenstein', code: 'LI'}, 
  {name: 'Lithuania', code: 'LT'}, 
  {name: 'Luxembourg', code: 'LU'}, 
  {name: 'Macao', code: 'MO'}, 
  {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
  {name: 'Madagascar', code: 'MG'}, 
  {name: 'Malawi', code: 'MW'}, 
  {name: 'Malaysia', code: 'MY'}, 
  {name: 'Maldives', code: 'MV'}, 
  {name: 'Mali', code: 'ML'}, 
  {name: 'Malta', code: 'MT'}, 
  {name: 'Marshall Islands', code: 'MH'}, 
  {name: 'Martinique', code: 'MQ'}, 
  {name: 'Mauritania', code: 'MR'}, 
  {name: 'Mauritius', code: 'MU'}, 
  {name: 'Mayotte', code: 'YT'}, 
  {name: 'Mexico', code: 'MX'}, 
  {name: 'Micronesia, Federated States of', code: 'FM'}, 
  {name: 'Moldova, Republic of', code: 'MD'}, 
  {name: 'Monaco', code: 'MC'}, 
  {name: 'Mongolia', code: 'MN'}, 
  {name: 'Montserrat', code: 'MS'}, 
  {name: 'Morocco', code: 'MA'}, 
  {name: 'Mozambique', code: 'MZ'}, 
  {name: 'Myanmar', code: 'MM'}, 
  {name: 'Namibia', code: 'NA'}, 
  {name: 'Nauru', code: 'NR'}, 
  {name: 'Nepal', code: 'NP'}, 
  {name: 'Netherlands', code: 'NL'}, 
  {name: 'Netherlands Antilles', code: 'AN'}, 
  {name: 'New Caledonia', code: 'NC'}, 
  {name: 'New Zealand', code: 'NZ'}, 
  {name: 'Nicaragua', code: 'NI'}, 
  {name: 'Niger', code: 'NE'}, 
  {name: 'Nigeria', code: 'NG'}, 
  {name: 'Niue', code: 'NU'}, 
  {name: 'Norfolk Island', code: 'NF'}, 
  {name: 'Northern Mariana Islands', code: 'MP'}, 
  {name: 'Norway', code: 'NO'}, 
  {name: 'Oman', code: 'OM'}, 
  {name: 'Pakistan', code: 'PK'}, 
  {name: 'Palau', code: 'PW'}, 
  {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
  {name: 'Panama', code: 'PA'}, 
  {name: 'Papua New Guinea', code: 'PG'}, 
  {name: 'Paraguay', code: 'PY'}, 
  {name: 'Peru', code: 'PE'}, 
  {name: 'Philippines', code: 'PH'}, 
  {name: 'Pitcairn', code: 'PN'}, 
  {name: 'Poland', code: 'PL'}, 
  {name: 'Portugal', code: 'PT'}, 
  {name: 'Puerto Rico', code: 'PR'}, 
  {name: 'Qatar', code: 'QA'}, 
  {name: 'Reunion', code: 'RE'}, 
  {name: 'Romania', code: 'RO'}, 
  {name: 'Russian Federation', code: 'RU'}, 
  {name: 'RWANDA', code: 'RW'}, 
  {name: 'Saint Helena', code: 'SH'}, 
  {name: 'Saint Kitts and Nevis', code: 'KN'}, 
  {name: 'Saint Lucia', code: 'LC'}, 
  {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
  {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
  {name: 'Samoa', code: 'WS'}, 
  {name: 'San Marino', code: 'SM'}, 
  {name: 'Sao Tome and Principe', code: 'ST'}, 
  {name: 'Saudi Arabia', code: 'SA'}, 
  {name: 'Senegal', code: 'SN'}, 
  {name: 'Serbia and Montenegro', code: 'CS'}, 
  {name: 'Seychelles', code: 'SC'}, 
  {name: 'Sierra Leone', code: 'SL'}, 
  {name: 'Singapore', code: 'SG'}, 
  {name: 'Slovakia', code: 'SK'}, 
  {name: 'Slovenia', code: 'SI'}, 
  {name: 'Solomon Islands', code: 'SB'}, 
  {name: 'Somalia', code: 'SO'}, 
  {name: 'South Africa', code: 'ZA'}, 
  {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
  {name: 'Spain', code: 'ES'}, 
  {name: 'Sri Lanka', code: 'LK'}, 
  {name: 'Sudan', code: 'SD'}, 
  {name: 'Suriname', code: 'SR'}, 
  {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
  {name: 'Swaziland', code: 'SZ'}, 
  {name: 'Sweden', code: 'SE'}, 
  {name: 'Switzerland', code: 'CH'}, 
  {name: 'Syrian Arab Republic', code: 'SY'}, 
  {name: 'Taiwan, Province of China', code: 'TW'}, 
  {name: 'Tajikistan', code: 'TJ'}, 
  {name: 'Tanzania, United Republic of', code: 'TZ'}, 
  {name: 'Thailand', code: 'TH'}, 
  {name: 'Timor-Leste', code: 'TL'}, 
  {name: 'Togo', code: 'TG'}, 
  {name: 'Tokelau', code: 'TK'}, 
  {name: 'Tonga', code: 'TO'}, 
  {name: 'Trinidad and Tobago', code: 'TT'}, 
  {name: 'Tunisia', code: 'TN'}, 
  {name: 'Turkey', code: 'TR'}, 
  {name: 'Turkmenistan', code: 'TM'}, 
  {name: 'Turks and Caicos Islands', code: 'TC'}, 
  {name: 'Tuvalu', code: 'TV'}, 
  {name: 'Uganda', code: 'UG'}, 
  {name: 'Ukraine', code: 'UA'}, 
  {name: 'United Arab Emirates', code: 'AE'},
  {name: 'United States Minor Outlying Islands', code: 'UM'}, 
  {name: 'Uruguay', code: 'UY'}, 
  {name: 'Uzbekistan', code: 'UZ'}, 
  {name: 'Vanuatu', code: 'VU'}, 
  {name: 'Venezuela', code: 'VE'}, 
  {name: 'Viet Nam', code: 'VN'}, 
  {name: 'Virgin Islands, British', code: 'VG'}, 
  {name: 'Virgin Islands, U.S.', code: 'VI'}, 
  {name: 'Wallis and Futuna', code: 'WF'}, 
  {name: 'Western Sahara', code: 'EH'}, 
  {name: 'Yemen', code: 'YE'}, 
  {name: 'Zambia', code: 'ZM'}, 
  {name: 'Zimbabwe', code: 'ZW'} 
];

const states = [
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District of Columbia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "U.S. Virgin Islands",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"
];

const territories = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon"
];

const Event = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [id, setId] = useState(location.state?.id);
    const setContext = useContext(Context)[1];
    const { role, metaData, firstName, lastName } = useContext(AccessContext);
    var _s = undefined;
    if (role == "Host/Guest")
        _s = { id: metaData.speakerId, firstName, lastName };
    if (id)
        setContext('Edit Event');
    else
        setContext('Add Event');
    const formatDateTime = (d) => {
        let year = d.getFullYear();
        let month = String(d.getMonth() + 1).padStart(2, '0');
        let day = String(d.getDate()).padStart(2, '0');
        let hours = String(d.getHours()).padStart(2, '0');
        let minutes = String(d.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    const defaultEvent = {
        title: '',
        location: '',
        cityState: '',
        ticketUrl: '',
        soldOut: false,
        datetime: formatDateTime(new Date(new Date((new Date()).setHours(12, 0, 0, 0)).setDate((new Date()).getDate()+1))),
        hosts: location.state?.speaker ? [location.state?.speaker] : (_s ? [_s] : []),
        guests: [],
        metaData: {}
    }
    const [event, setEvent] = useState(defaultEvent);
    useEffect(() => {
        if (!id) {
            setEvent(defaultEvent);
        }
    },[role]);
    const [loading, setLoading] = useState(id ? true : false);
    const [hosts, setHosts] = useState([]);
    const [guests, setGuests] = useState([]);
    const [hostId, setHostId] = useState(-1);
    const [guestId, setGuestId] = useState(-1);
    const loadEvent = () => {
        axios.post(process.env.REACT_APP_API_URL + 'event', {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                setEvent(r.data.results);
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadEvent();
        } else {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        /*axios.post(process.env.REACT_APP_API_URL + 'host').then(r => {
            if (r?.data?.status === 'Success') {
                setHosts(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'guest').then(r => {
            if (r?.data?.status === 'Success') {
                setGuests(r.data.results);
            }
        });*/
    }, []);
    const setValue =(key, value) => {
        setEvent(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const setMetaData = (key, value) => {
        setEvent(h => {
            let _h = { ...h };
            _h.metaData = _h.metaData || {};
            _h.metaData[key] = value;
            return _h;
        });
    }

    const validateInput = (value, input) => {
        const errorStyles = "outline: 2px red solid;";
        if (!input) return true;
        if (!value) {
            input.setAttribute('style', errorStyles);
            input.setAttribute('aria-invalid', 'true');
            return false;
        } else {
            input.removeAttribute('style');
            input.setAttribute('aria-invalid', 'false');
            return true;
        }
    }

    const validate = () => {
        var isValid = true;
        const titleInput = document.getElementById('title');
        const ticketInput = document.getElementById('ticket');
        const daytimeInput = document.getElementById('datetime');
        const cityInput = document.getElementById('city');
        const countryInput = document.querySelector('#country .sd-toggle-btn');
        const stateInput = document.querySelector('#state .sd-toggle-btn');
        const territoryInput = document.querySelector('#territory .sd-toggle-btn');
        const countryCodeInput = document.getElementById('country-code');

        isValid = validateInput(event.title, titleInput) && isValid;
        isValid = validateInput(event.ticketUrl, ticketInput) && isValid;
        isValid = validateInput(event.datetime, daytimeInput) && isValid;
        isValid = validateInput(event.metaData?.country, countryInput) && isValid;
        isValid = validateInput(event.cityState, cityInput) && isValid;
        isValid = validateInput(event.metaData?.state, stateInput) && isValid;
        isValid = validateInput(event.metaData?.state, territoryInput) && isValid;
        isValid = validateInput(event.metaData?.countryCode, countryCodeInput) && isValid;

        return isValid;
    }
    const save = () => {
        if (!validate())
            return;
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'event/add', {
                title: event.title,
                location: event.location,
                cityState: event.cityState,
                ticketUrl: event.ticketUrl,
                soldOut: event.soldOut,
                datetime: event.datetime ? event.datetime : '',
                hosts: JSON.stringify((event.hosts || []).map(h => h.id)),
                guests: JSON.stringify((event.guests || []).map(g => g.id)),
                metaData: JSON.stringify(event.metaData || {})
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setLoading(true);
                }
            });
        } else {
            axios.post(process.env.REACT_APP_API_URL + 'event/update', {
                id: id,
                title: event.title,
                location: event.location,
                cityState: event.cityState,
                ticketUrl: event.ticketUrl,
                soldOut: event.soldOut,
                datetime: event.datetime ? event.datetime : '',
                hosts: JSON.stringify((event.hosts || []).map(h => h.id)),
                guests: JSON.stringify((event.guests || []).map(g => g.id)),
                metaData: JSON.stringify(event.metaData || {})
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setLoading(true);
                    loadEvent();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'event/delete', {
            ids: JSON.stringify([id])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/event-list');
            }
        });
    }
    const filterArrays = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a.id === b.id;
            });
        });
    }
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form speaker-form f-start">
                    <div className="mb-0 w-100">
                        <h1 className="page-title">{id ? 'Update' : 'Create'} Event</h1>
                        <h2 className="page-subtitle">{id ? 'Update the event' : 'Add a new event'} for your {role == "Host/Guest" ? 'account' : 'podcast'}.</h2>
                    </div>
                    <div className="content-box">
                        <div class="content-header">
                            <div className="flex f-row a-center f-between">
                                <div>
                                    <h3>Event Info</h3>
                                    <h4>Basic information about your event</h4>
                                </div>
                                <Toggle value={event.soldOut} label="Event Sold Out" id="sold-out" onChange={e => setValue('soldOut', e.target.checked)} />
                            </div>
                        </div>
                        <div className="content-body">
                            <div className="w-100 sm-w-100 p-rel gap-10 f-wrap f-row">
                                <div className="w-100">
                                    <label htmlFor="title">Title</label>
                                    <input type="text" id="title" required placeholder='Event Title' value={event.title} onChange={(e) => setValue('title', e.target.value)} />
                                </div>
                                <div className="w-60 xs-w-100">
                                    <label htmlFor="ticket">Ticket Url</label>
                                    <input type="text" id="ticket" required value={event.ticketUrl} onChange={(e) => setValue('ticketUrl', e.target.value)} />
                                </div>
                                <div className="w-40 xs-w-100">
                                    <label htmlFor="datetime">Date & Time</label>
                                    <input id="datetime" type="datetime-local" required value={formatDateTime(new Date(event.datetime || new Date()))} onChange={(e) => setValue('datetime', e.target.value)} />
                                </div>
                                <div className="w-100" id="country">
                                    <label>Country</label>
                                    <SearchableDropdown value={event.metaData?.country} onChange={val => {
                                        setMetaData('country', val);
                                        var countryCode = countries.find(x => x.name == val)?.code;
                                        setMetaData('countryCode', countryCode);
                                    }} options={countries.reduce((acc, cur) => {
                                        acc.push(cur.name);
                                        return acc;
                                    }, [])} label="Country" />
                                </div>
                                {/*<div className="w-50">
                                    <label htmlFor="location">Location</label>
                                    <input type="text" id="location" value={event.location} onChange={(e) => setValue('location', e.target.value)} />
                                </div>*/}
                                {!!event.metaData?.country && (
                                    <>
                                        <div className="w-40 xs-w-100">
                                            <label htmlFor="city">City</label>
                                            <input type="text" id="city" required value={event.cityState} onChange={(e) => setValue('cityState', e.target.value)} />
                                        </div>
                                        {event.metaData?.country == "United States" ? (
                                            <>
                                                <div className="w-40 xs-w-50" id="state">
                                                    <label>State</label>
                                                    <SearchableDropdown value={event.metaData?.state} onChange={val => setMetaData('state', val)} options={states} label="State" />
                                                </div>
                                                <div className="w-20 xs-w-50">
                                                    <label htmlFor="zip">Zip Code (Optional)</label>
                                                    <input id="zip" type="text" value={event.metaData?.zip} onChange={(e) => setMetaData('zip', e.target.value)} />
                                                </div>
                                            </>
                                        ) : event.metaData?.country == "Canada" ? (
                                            <>
                                                <div className="w-40 xs-w-50" id="territory">
                                                    <label>Territory</label>
                                                    <SearchableDropdown value={event.metaData?.territory} onChange={val => setMetaData('territory', val)} options={territories} label="Territory" />
                                                </div>
                                                <div className="w-20 xs-w-50">
                                                    <label htmlFor="postal">Postal Code (Optional)</label>
                                                    <input id="postal" type="text" value={event.metaData?.zip} onChange={(e) => setMetaData('zip', e.target.value)} />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="w-40 xs-w-50">
                                                    <label htmlFor="country-code">Country Code</label>
                                                    <input id="country-code" type="text" required value={event.metaData?.countryCode} onChange={(e) => setMetaData('countryCode', e.target.value)} />
                                                </div>
                                                <div className="w-20 xs-w-50">
                                                    <label htmlFor="postal">Postal Code (Optional)</label>
                                                    <input id="postal" type="text" value={event.metaData?.zip} onChange={(e) => setMetaData('zip', e.target.value)} />
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className="w-100 content-box">
                        <div className="content-body">
                            <div className="w-100 f-end f-row a-center" style={{order: 10}}>
                                <div className="pod-date-string" style={{color: '#99A1AF'}}>
                                    Fill in the event details above
                                </div>
                                <div className="flex f-center f-row gap-15" style={{flexGrow: 0}}>
                                    <Link className="btn btn-white flex f-row g-5" to={location.state?.returnTo ? location.state?.returnTo : "/event-list"} state={location.state?.speaker ? {id: location.state?.speaker.id} : null}>
                                        Cancel
                                    </Link>
                                    <button onClick={save} className="btn flex f-row g-5">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.3327 14V9.33329C11.3327 9.15648 11.2624 8.98691 11.1374 8.86189C11.0124 8.73686 10.8428 8.66663 10.666 8.66663H5.33268C5.15587 8.66663 4.9863 8.73686 4.86128 8.86189C4.73625 8.98691 4.66602 9.15648 4.66602 9.33329V14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4.66602 2V4.66667C4.66602 4.84348 4.73625 5.01305 4.86128 5.13807C4.9863 5.2631 5.15587 5.33333 5.33268 5.33333H9.99935" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Save
                                    </button>
                                    {id && <button onClick={_delete} className="btn btn-red">Delete</button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Event;